<template>
  <b-table :data="data" :loading="loading">
    <template slot-scope="props">
      <b-table-column field="Reply" label="Nome do formulário" width="20%">
        {{ labelType[props.row.type][1] }}
      </b-table-column>
      <b-table-column field="Recipients" label="Destinatários">
        {{ props.row.emails.join(', ') }}
      </b-table-column>
      <b-table-column label="Opções">
        <router-link
          :to="`${props.row.type}/editType`"
          tag="button"
          type="button"
          v-app-button.icon-only
          v-tooltip.bottom="'Editar'"
        >
          <b-icon size="is-small" icon="pencil"></b-icon>
        </router-link>
      </b-table-column>
    </template>
    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import FormRecipientService from '@/services/form-recipient.service';
import { FormRecipientsTypeLabel } from '@/enums/FormRecipientsEnum';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'form-recipients-table',
  mixins: [ToastMixin],
  data: () => {
    return {
      data: [],
      loading: false,
      labelType: Array.from(FormRecipientsTypeLabel),
    };
  },
  methods: {
    load() {
      this.load = true;
      FormRecipientService.get()
        .then((response) => {
          this.data = response.data;
        })
        .catch(() => this.toastify('Erro ao carregar informações.', 'error'))
        .finally(() => (this.loading = false));
    },
    edit(id) {
      this.$router.push(`${id}/edittyo`);
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.contacts_reply {
  margin-top: 15px;
  color: red;
}
</style>
